export const SHOW_MODAL = 'app/CalculatorPage/SHOW_MODAL';
export const FORM_SENDED = 'app/CalculatorPage/FORM_SENDED';
